export default __webpack_public_path__ + "static/media/refter.d9433049.png";